/* eslint-disable no-unused-vars */
import {
  Box, Divider, makeStyles, Typography,
} from '@material-ui/core';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  container: {
    margin: theme.spacing(2, 0),
  },
  containerResponse: {
    display: 'flex',
    flexDirection: 'row',
    margin: theme.spacing(2, 0),
  },
  iconCheck: {
    color: theme.palette.background.green,
    margin: theme.spacing(0, 2),
  },
  iconWrong: {
    color: theme.palette.background.red,
    margin: theme.spacing(0, 2),
  },
  divider: {
    background: theme.palette.background.default,
    height: 3,
  },
  text: {
    fontFamily: 'Raleway',
  },
  containerSection: {
    margin: theme.spacing(1, 0),
  },
}));
function ListAnswers({ list }) {
  const classes = useStyles();
  return (
    <Box>
      {list.map((e) => (
        <Box className={classes.container} key={e.id}>
          <Box className={classes.containerSection}>
            <Typography className={classes.text}>
              {e.question}
            </Typography>
          </Box>
          <Box className={classes.containerResponse}>
            <Box>
              { e.correct ? <CheckCircleOutlineRoundedIcon className={classes.iconCheck} />
                : <HighlightOffRoundedIcon className={classes.iconWrong} />}
            </Box>
            <Box>
              <Typography className={classes.text}>
                {e.correctAnswer}
              </Typography>
            </Box>
          </Box>
          <Divider className={classes.divider} />
        </Box>
      ))}
    </Box>
  );
}

export default ListAnswers;

// corregir props
ListAnswers.propTypes = {
  list: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]))).isRequired,
};
